import { useSelector } from 'react-redux'

export const HOT_SWAP_STATUS = {
    open: 'open',
    shipped: 'shipped',
    finished: 'finished'
}

// US = UpdateService; SBU = SwapByUser
export const HOTSWAP_TYPES = { US: 'update_service', SBU: 'swap_by_user' }

export const RESPONSIBLE_OR_TRACKING = {
    update_service: 'technician_email',
    swap_by_user: 'tracking_number'
}

export const inputParameters = () => {
    const { locale } = useSelector(state => state.main)

    return {
        firstNameInput: {
            label: locale.addressForm.firstName,
            register: 'firstName'
        },
        lastNameInput: {
            label: locale.addressForm.lastName,
            register: 'lastName'
        },
        companyInput: {
            label: locale.addressForm.company,
            register: 'company'
        },
        addressInput: {
            label: locale.addressForm.streetAndNumber,
            register: 'streetAndNumber'
        },
        zipCodeInput: {
            label: locale.addressForm.zip,
            register: 'zipCode'
        },
        cityInput: {
            label: locale.addressForm.city,
            register: 'city'
        },
        countryInput: {
            label: locale.addressForm.country,
            register: 'country'
        },
        noteInput: {
            label: locale.addressForm.note,
            register: 'note'
        }
    }
}

export const hotswapStatusOptions = {
    shipped: 'shipped',
    finished: 'finished',
    open: 'open',
    pending: 'pending'
}
